<template>
    <tab_header icon="fa-solid fa-edit" title="Editar Dados" />

    <div v-if="form.wasSuccessful" class="alert alert-success d-flex align-items-center p-5 mb-10" id="success-alert">
        <span class="svg-icon svg-icon-2hx svg-icon-success me-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none">
                <path opacity="0.3"
                    d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z"
                    fill="black"></path>
                <path
                    d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z"
                    fill="black"></path>
            </svg>
        </span>
        <div class="d-flex flex-column">
            <h4 class="mb-1 text-success">Tudo certo !</h4>
            <p class="m-0 text-sucess">
                Computador atualizado com sucesso !
            </p>
        </div>
    </div>

    <div v-if="form.hasErrors" class="alert alert-danger d-flex align-items-center p-5 mb-10" id="error-alert">
        <span class="svg-icon svg-icon-2hx svg-icon-danger me-4">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none">
                <path opacity="0.3"
                    d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z"
                    fill="black"></path>
                <path
                    d="M10.5606 11.3042L9.57283 10.3018C9.28174 10.0065 8.80522 10.0065 8.51412 10.3018C8.22897 10.5912 8.22897 11.0559 8.51412 11.3452L10.4182 13.2773C10.8099 13.6747 11.451 13.6747 11.8427 13.2773L15.4859 9.58051C15.771 9.29117 15.771 8.82648 15.4859 8.53714C15.1948 8.24176 14.7183 8.24176 14.4272 8.53714L11.7002 11.3042C11.3869 11.6221 10.874 11.6221 10.5606 11.3042Z"
                    fill="black"></path>
            </svg>
        </span>
        <div class="d-flex flex-column">
            <h4 class="mb-1 text-danger">Atenção!</h4>
            <p class="m-0"
                v-for="error, index in form.errors"
                :key="index">{{ error }}
            </p>
        </div>
    </div>

    <form @submit.prevent="submit()">
        <div class="row">
            <div class="form-group col-12 col-md-3 ">
                <label for="descricao" class="required fw-bold">Descrição</label>
                <input
                    type="text"
                    v-model="form.descricao"
                    id="descricao"
                    class="form-control required">
            </div>
            <div class="form-group col-12 col-md-3 ">
                <label for="status" class="required fw-bold">Status</label>
                <select
                    v-model="form.status"
                    id="status"
                    class="form-control form-select select2">
                    <option value="Ativo">Ativo</option>
                    <option value="Inativo">Inativo</option>
                    <option value="Pendente">Pendente</option>
                </select>
            </div>
            <div class="form-group col-12 col-md-3">
                <label for="dvr" class="required fw-bold">Dvr vinculado</label>
                <select
                    v-model="form.dvr_id"
                    id="dvr"
                    class="form-control form-select select2"
                >
                    <option value="">Selecione o dvr</option>
                    <option
                        v-for="dvr in props.dvrs"
                        :key="dvr.id"
                        :value="dvr.id">
                        {{ dvr.name }}
                    </option>
                </select>
            </div>
            <div class="form-group col-12 col-md-3 mb-5">
                <label for="uid" class="required fw-bold">UID</label>
                <input
                    readonly
                    type="text"
                    v-model="form.uid"
                    id="uid"
                    class="form-control form-control-solid required"
                >
            </div>
            <div class="col-9" v-if="props.is_master_user">
                <label for="cfc" class="required fw-bold">CFC</label>
                <select
                    v-model="form.subtenant_id"
                    id="cfc"
                    class="form-control form-select  select2">
                    <option
                        v-for="subtenant in props.subtenant_list"
                        :key="subtenant.id"
                        :value="subtenant.id">
                        {{ subtenant.apelido }}
                    </option>
                </select>
            </div>
             <div class="form-group col-3 col-md-3 mb-5">
                <label for="display_order" class="required fw-bold">Ordem de visualização</label>
                <input
                    type="text"
                    v-model="form.display_order"
                    id="display_order"
                    class="form-control required"
                >
            </div>
            <div class="form-group col-12 col-md-3 mb-5">
                <label for="webcam_streaming_mode" class="required fw-bold">Modo da webcam</label>
                <select
                    v-model="form.webcam_streaming_mode"
                    id="webcam_streaming_mode"
                    class="form-control form-select">
                    <option value="agent">Agente</option>
                    <option value="browser_webrtc">Browser WebRTC</option>
                </select>
            </div>
            <div class="form-group col-12 mt-5">
                <button type="submit" class="btn btn-success btn-rounded">Salvar</button>
            </div>
        </div>
    </form>
</template>

<script setup lang="ts">
import { Computer } from 'resources/js/Interfaces/Computer';
import tab_header from './tab_header.vue';
import { SubTenant } from 'resources/js/Interfaces/SubTenant';
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    'computer': { type: Object as () => Computer, required: true },
    'dvrs': { type: Object, required: true },
    'subtenant_list': { type: Array<SubTenant>, required: true },
    'is_master_user': {type: Boolean, required: true},
    'update_computer_url': {type: String, required: true}
});

const cfc_index = props.subtenant_list.findIndex(item => item.id === props.computer.subtenant_id);
const form = useForm({
    descricao: props.computer.descricao,
    status: props.computer.status,
    dvr_id: props.computer.dvr_id,
    uid: props.computer.uid,
    subtenant_id: props.subtenant_list[cfc_index].id,
    display_order: props.computer.display_order,
    webcam_streaming_mode: props.computer.webcam_streaming_mode ?? 'agent',
});

function submit(){
    form.put(props.update_computer_url)
}
</script>
